import React, { useEffect } from 'react';
import { generatePath, useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { useStoreUnitActions } from 'src/redux/helpers';
import companiesStore from 'src/pages/Companies/redux/companiesStore';
import { useSolutionUnassignedCompaniesOptions } from '../../redux';
import { API_SOLUTION_COMPANIES_UPDATE } from '../../constants';
import { getAssignTemplateFormFields } from '../formFields';

type Props = {
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionCompaniesAssignModal({ open, onClose }: Props) {
  const [options, optionsLoading] = useSolutionUnassignedCompaniesOptions();
  const actions = useStoreUnitActions(companiesStore);
  const { showAlert } = useAlert();
  const { solutionId } = useParams();

  const [handleSubmit, saving] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generatePath(API_SOLUTION_COMPANIES_UPDATE, { solutionId }),
        params,
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: 'Contracts have been updated',
        text: 'Companies assigned for current solution have been updated successfully.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  const [form, handleSaveSelection] = useForm({
    fields: getAssignTemplateFormFields(options, optionsLoading),
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    actions.list();
  }, []);

  return (
    <ModalDialog
      open={open}
      title="Assign company"
      onClose={onClose}
      onConfirm={handleSaveSelection}
      confirmBtnText="Save"
      loading={saving}
      maxWidth="sm"
      fullWidth
    >
      {form}
    </ModalDialog>
  );
}

export default SolutionCompaniesAssignModal;
